import FormEngineContainer from '@form-engine/core-application/components/container';
import FormEngineElement from '@form-engine/core-application/components/element';
import { FormEngineStateProvider } from '@form-engine/core-application/components/engine';
import { WorkflowState } from '@form-engine/core-application/hooks/use-workflow';
import {
    FormPreset,
    FormSession,
} from '@form-engine/core-application/types/form';
import uuidv4 from '@form-engine/core-util/uuid';
import React, { useCallback, useMemo } from 'react';
import BuilderScaledContainer from './scaled-container';
import ErrorBoundary from '@form-engine/builder-application/components/error-boundary';
import Builder from '@form-engine/builder-application';

export interface BuilderFormPresetPreviewProps {
    preset?: FormPreset;
}

export function BuilderFormPresetPreviewError() {
    const { Node } = Builder.i18n;
    return <Node id="form-editor.formPresetPreview.notRenderable" />;
}

export default function BuilderFormPresetPreview({
    preset,
}: BuilderFormPresetPreviewProps) {
    const { form, session, workflow } = useMemo(() => {
        return {
            form: {
                ...(preset?.data ?? {}),
                id: uuidv4(),
            } as FormDefinition,
            session: { isMock: true } as FormSession,
            workflow: {} as WorkflowState,
        };
    }, [preset]);

    const handlePreviewSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    if (!form?.elements?.length) return null;

    return (
        <BuilderScaledContainer>
            <ErrorBoundary errorComponent={BuilderFormPresetPreviewError}>
                <FormEngineStateProvider {...{ form, session, workflow }}>
                    <form
                        onSubmit={handlePreviewSubmit}
                        className="fe is-initialized"
                    >
                        <div className="fe-elements">
                            <FormEngineElement
                                editMode={true}
                                id={form.elements[0].id}
                                elementComponent={FormEngineElement}
                                containerComponent={FormEngineContainer}
                            />
                        </div>
                    </form>
                </FormEngineStateProvider>
            </ErrorBoundary>
        </BuilderScaledContainer>
    );
}
